function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M40.145 6.164L7.855 41.837V6.164h32.29z",
  fillOpacity: 0.502,
  fillRule: "nonzero"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.145 41.836L7.855 6.163v35.673h32.29z",
  fillRule: "nonzero"
});

var SvgKadenceBlocks = function SvgKadenceBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
};

export default SvgKadenceBlocks;